// Shared file-type icon selection so the composer's pending-attachment chips
// and sent-message attachment cards render identical icons for the same
// file type instead of two independently-drifting implementations.

import { File, FileSpreadsheet, FileText, Image, Presentation, type LucideIcon } from 'lucide-react';
import { extensionOf } from './uploadConstraints';

const IMAGE_EXTENSIONS = new Set(['.png', '.jpg', '.jpeg', '.gif', '.webp']);

export function isImageContentType(contentType: string | undefined): boolean {
  return !!contentType?.startsWith('image/');
}

// The backend accepts uploads by extension and stores a missing browser MIME
// type as application/octet-stream, so fall back to the filename then.
export function isImageFile(contentType: string | undefined, filename: string | undefined): boolean {
  if (isImageContentType(contentType)) return true;
  const generic = !contentType || contentType === 'application/octet-stream';
  return generic && !!filename && IMAGE_EXTENSIONS.has(extensionOf(filename));
}

export function pickFileTypeIcon(contentType: string | undefined, filename: string | undefined): LucideIcon {
  if (isImageContentType(contentType)) return Image;
  const hay = `${contentType ?? ''} ${filename ?? ''}`.toLowerCase();
  if (/(sheet|excel|csv|xlsx?)/.test(hay)) return FileSpreadsheet;
  if (/(presentation|powerpoint|pptx?)/.test(hay)) return Presentation;
  if (/(pdf|text|markdown|\.md$|\.txt$)/.test(hay)) return FileText;
  return File;
}
